module.exports = __webpack_public_path__ + "static/media/r14.76ef204b.jpg";